module.exports = __webpack_public_path__ + "img/diagram-1.6fba70f4.svg";